import { useEffect, useState } from 'react';
import type { Entity } from '~/entities/types';
import { getEntityName } from './helpers';
import { useEntityPii } from '~/entities/hooks';

type EntityNamesType = {
  [key: string]: string;
};

const updateSSRNames = (name: string, token: string) => {
  // tech debt: bypassing needing for SPA migration
  const breadcrumb = document.getElementsByClassName('breadcrumbs');
  if (!breadcrumb.length) return;
  const dom = breadcrumb[0] as HTMLElement;
  if (dom.dataset.isSpa) return;
  const anchors = Array.from(dom.querySelectorAll('a'));
  anchors.forEach(each => {
    const reg = new RegExp(`/entities/${token}/$`);
    if (each.href.match(reg)) {
      each.innerHTML = name;
    }
  });
  const title = document.querySelector('head title') as HTMLTitleElement;
  if (!title) return;
  title.innerHTML = title.innerHTML.replace(/^([^|]+)/, `${name} `);
};

export const useFetchedEntityName = (entity: Entity) => {
  const [currentEntityName, setCurrentEntityName] = useState('');
  const [entityNames, setEntityNames] = useState<EntityNamesType>({});
  const {
    entity_token: entityToken,
  } = entity || {};
  const {
    data: piiData,
    isLoading: isPiiLoading,
  } = useEntityPii({ entityToken });

  useEffect(() => {
    if (isPiiLoading || !entityToken || !piiData) return;
    if (entityNames[entityToken]) {
      if (entityNames[entityToken] !== currentEntityName) {
        setCurrentEntityName(entityNames[entityToken]);
      }
      return;
    }

    const name = getEntityName(entity, piiData);
    updateSSRNames(name, entityToken);

    setEntityNames({
      ...entityNames,
      [entityToken]: name,
    });
    setCurrentEntityName(name);
  }, [isPiiLoading, piiData, entity, entityToken, currentEntityName, entityNames]);

  return { currentEntityName };
};
